import { QcpCertificateInformation } from "@/type/core/qcp/qcp.types";
import configuration from "@/utils/Config";
import { restGetHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";

const baseUrl = configuration.backendBaseUrl;
const certificateQcpInformationUrl =
  baseUrl + "/ws/fo/certificate/qcp/information";

export const requestGetCertificateQcpInformation = createEffect({
  handler: restGetHandler<QcpCertificateInformation>(
    certificateQcpInformationUrl,
  ),
});
